export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

export function welcome () {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor((Math.random() * arr.length))
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent () {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate (id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

// cookie操作
export const cookie = {
  get (key) {
    let arr = []
    const reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')

    arr = document.cookie.match(reg)
    // 如果获取到cookie，则直接返回数据
    if (arr) {
      return unescape(arr[2] === 'null' ? null : arr[2])
    }
    return null
  },
  set (key, value, time) {
    const Days = time || 30
    const exp = new Date()
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie = key + '=' + escape(value) + ';expires=' + exp.toGMTString()
  },
  remove (key) {
    const exp = new Date()
    exp.setTime(exp.getTime() - 1)
    const cval = cookie.get(key)
    if (cval) {
      document.cookie = name + "='';expires=" + exp.toGMTString()
    }
  }
}

// sessionStorage
export const session = {
  get (key) {
    return JSON.parse(sessionStorage.getItem(key))
  },
  set (key, value) {
    sessionStorage.setItem(key, JSON.stringify(value))
  },
  remove (key) {
    sessionStorage.removeItem(key)
  },
  clear () {
    sessionStorage.clear()
  }
}
// localStorage
export const storage = {
  get (key) {
    return JSON.parse(localStorage.getItem(key))
  },
  set (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  remove (key) {
    localStorage.removeItem(key)
  },
  clear () {
    localStorage.clear()
  }
}
// 计算某个日期距离当前日期相差多少天
export function countIntervalDay (date) {
  const timestamp = date.replace(/-/g, '/') // 兼容ie
  const date1 = new Date(timestamp)
  const date2 = new Date()
  const result = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24)
  return result
}

// 时间格式处理
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  // alert(timeStr)
  return timeStr
}

// 转换post请求方式下的data数据格式，转为formData格式
export function transformRequest (postData) {
  let ret = ''
  for (const it in postData) {
    // if (postData[it] instanceof Array) {
    //   // return JSON.parse(JSON.stringify(postData))
    //   return postData
    // }
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(postData[it]) + '&'
  }
  return ret ? ret.slice(0, -1) : ''
}

// JSON对象，转成formData对象
export function JsonToFormData (params) {
  const formData = new FormData()
  Object.keys(params).forEach(key => {
    formData.append(key, params[key])
  })
  return formData
}

// formData对象，转成JSON对象
export function FormDataToJson (formData) {
  const jsonData = {}
  formData.forEach((value, key) => {
    jsonData[key] = value
  })
  // console.log(jsonData)
  return jsonData
}

// 数组去重
export function uniqueArr (arr) {
  var hash = []
  for (var i = 0; i < arr.length; i++) {
    if (hash.indexOf(arr[i]) === -1) {
      hash.push(arr[i])
    }
  }
  return hash
}

// 将VantV中F2的图表数据源，转换为 Viser的图表数据源
/**
 *
 * @param {Array} oldData 数据源
 * @param {String} legendN 图例对应的字段名
 * @param {String} xName X轴对应的字段名
 * @param {String} yName Y轴对应的字段名
 */
export function formatChartData (oldData, legendN, xName, yName) {
  // console.log(oldData)
  if (!oldData || String(oldData) === '{}') {
    return {}
  }
  // 拿到所有legend的值
  const legendArr = uniqueArr(oldData.map(item => item[legendN]))
  // X轴对应的fields
  const xFields = []
  // console.log(legendArr)
  // 根据每一个legend的值，获取其对应的xy轴值
  let newData = []
  newData = legendArr.map(item => {
    return { name: item }
  })
  // console.log(newData)
  // 找到是哪个legend对应的数据
  legendArr.forEach((legend, legendIndex) => {
    oldData.forEach(item => {
      // 获取每一项的field
      xFields.push(item[xName])
      // 根据图例获取对应的数据
      if (newData[legendIndex].name === item[legendN]) {
        newData[legendIndex][item[xName]] = item[yName]
      }
    })
  })
  // console.log(newData)
  const newXfields = uniqueArr(xFields)
  return {
    chartData: newData,
    xFields: newXfields
  }
}

// 金额加逗号处理
export function moneyComma (num) {
  // if (!num || num === '-') {
  //   return '-'
  // }
  num = Number(num).toFixed(2)
  return String(num).replace(/\d(?=(?:\d{3})+\b)/g, '$&,')
}

// 文件流下载
export function BolbFileDownLoad (fileBlob, name = '', type = '') {
  // console.log(fileBlob)
  if (myBrowser() === 'IE') {
    window.navigator.msSaveBlob(fileBlob, name)
  } else {
    const url = type ? window.URL.createObjectURL(new Blob([fileBlob], { type })) : window.URL.createObjectURL(new Blob([fileBlob]))
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
  }
}

// 判断浏览器类型
function myBrowser () {
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  if (userAgent.indexOf('OPR') > -1) {
    return 'Opera'
  } // 判断是否Opera浏览器 OPR/43.0.2442.991
  if (userAgent.indexOf('Firefox') > -1) {
    return 'FF'
  } // 判断是否Firefox浏览器  Firefox/51.0
  if (userAgent.indexOf('Trident') > -1) {
    return 'IE'
  } // 判断是否IE浏览器  Trident/7.0 rv:11.0
  if (userAgent.indexOf('Edge') > -1) {
    return 'Edge'
  } // 判断是否Edge浏览器  Edge/14.14393
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome'
  } // Chrome/56.0.2924.87
  if (userAgent.indexOf('Safari') > -1) {
    return 'Safari'
  } // 判断是否Safari浏览器 AppleWebKit/534.57.2 Version/5.1.7 Safari/534.57.2
}

// 获取服务器端的时间
export function _fetchServerTime () {
  return new Promise((resolve, reject) => {
    var xhr = null
    if (window.XMLHttpRequest) { // 如果浏览器存在这个对象 则以这种方式创建
      xhr = new XMLHttpRequest()
    } else { // 否则 以下面这种方式
      xhr = new ActiveXObject('Microsoft.XMLHTTP')
    }
    xhr.open('GET', location.href, true)
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        resolve(xhr.getResponseHeader('Date'))
      }
    }
    xhr.send(null)
  })
}
